import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';

export function useGetTurmaSituacao_das_turmas_no_ano() {
  const [situacao_das_turmas_no_ano, set_media_alunos_por_turma_no_ano] = useState<any>(null);

  async function handleSituacao_das_turmas_no_ano(year?:string) {
    const { data } = await api.get('/reports/situacao_das_turmas_no_ano', {
      params: {
        year,
      },
    });
    set_media_alunos_por_turma_no_ano(data);
  }

  useEffect(() => {
    handleSituacao_das_turmas_no_ano();
  }, []);
  return { situacao_das_turmas_no_ano, handleSituacao_das_turmas_no_ano };
}
